import http from '@/http/service'
 


export default function Promocoes(params={}){

    return http.get("/parceiro/promocoes",{ params })

}